export function ErrorMessage({ error }: { error?: Error | null }) {
  if (!error) return <></>;

  return <div style={{ color: 'red' }}>{error.message}</div>;
}
